(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-podcast-show"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-podcast-archive]').forEach((root) => {
        if (root.dataset.initialized) return;
        const cards = [...root.querySelectorAll('[data-episode-card]')];
        const size = Number(root.dataset.pageSize) || 12;
        root.dataset.initialized = 'true';
        const normalize = (text) => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9&]+/g, ' ').trim();
        const index = cards.map((card) => ({ card, text: normalize(card.dataset.searchText) }));
        const form = root.querySelector('[data-archive-search]');
        const input = form.querySelector('[data-archive-query]');
        const clear = form.querySelector('[data-archive-clear]');
        const results = form.querySelector('[data-search-status]');
        const empty = root.querySelector('[data-search-empty]');
        const controls = root.querySelector('[data-archive-pagination]');
        const previous = controls.querySelector('[data-archive-prev]');
        const next = controls.querySelector('[data-archive-next]');
        const status = controls.querySelector('[data-archive-status]');
        let filtered = cards;
        let total = Math.ceil(filtered.length / size);
        let current = 1;
        const show = (page, focus = false) => {
          current = Math.min(Math.max(1, total), Math.max(1, page));
          const visible = new Set(filtered.slice((current - 1) * size, current * size));
          cards.forEach((card) => { card.hidden = !visible.has(card); });
          previous.disabled = current === 1;
          next.disabled = current >= total;
          controls.hidden = total < 2;
          status.textContent = status.dataset.format.replace('[current]', current).replace('[total]', total);
          if (focus) root.querySelector('#all-episodes h2').focus();
        };
        previous.addEventListener('click', () => show(current - 1, true));
        next.addEventListener('click', () => show(current + 1, true));
        const search = () => {
          const query = normalize(input.value);
          const terms = query.split(' ').filter(Boolean);
          filtered = terms.length ? index.filter((entry) => terms.every((term) => entry.text.includes(term))).map((entry) => entry.card) : cards;
          total = Math.ceil(filtered.length / size);
          clear.hidden = !input.value;
          results.hidden = !query;
          results.textContent = results.dataset.format.replace('[count]', filtered.length);
          empty.hidden = filtered.length !== 0;
          show(1);
        };
        form.addEventListener('submit', (event) => event.preventDefault());
        input.addEventListener('input', search);
        input.addEventListener('search', search);
        clear.addEventListener('click', () => { input.value = ''; search(); input.focus(); });
        form.hidden = false;
        show(1);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rrg-podcast-transcript"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#episode-transcript"]');
    if (link) {
      const details = document.querySelector('#episode-transcript details');
      if (details) details.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
